import { render, staticRenderFns } from "./TabletConfigDialog.vue?vue&type=template&id=746927e6"
import script from "./TabletConfigDialog.vue?vue&type=script&lang=js"
export * from "./TabletConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports